import { FormSchema } from '@features/executive-report/subdomains/visitation/domain/v2/form-schema';
import { buildDefaultValues } from './default-values-v2';

export const buildClientDefaultValuesV2 = (
  campaignName: string
): FormSchema => {
  const defaultFields = buildDefaultValues(campaignName, {});

  return {
    ...defaultFields,
    includedSlides: {
      ...defaultFields.includedSlides,
      intro: {
        ...defaultFields.includedSlides.intro,
        agenda: false,
      },
    },
  };
};
